import React, { useState } from "react";
import { PageHeading } from "../../../components/ui/PageHeading";
import SearchInput from "../../../components/ui/SearchInput";
import { Button } from "../../../components/ui/button";
import MealTable from "../meal/MealTable"
import MealFilter from "./MealFilter";
import { useDeleteMealsMutation } from "../../../featureSlice/mealSliceApi";
import DeleteModal from "../../../components/ui/DeleteModal";

const SettingMeal = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [editData, setEditData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);

      const [deleteMealItem] = useDeleteMealsMutation();
    
  const handleAddClick = () => {
    setShowFilter(true);
    setEditData(null);  
  };
const handleEditClick = (row) => {
    setEditData(row);        
    setShowFilter(true);    
  };

   const handleDeleteClick = (id) => {
    setDeleteId(id);
    setIsDeleteOpen(true);
  };

   const handleDeleteAction = async (id) => {
    try {
      await deleteMealItem(id).unwrap();
    } catch (error) {
      console.error("Delete failed", error);
    }
  };
  return (
    <div className="px-5">
      <PageHeading title="Setting >> Meal" className=" " />

      <div className="flex justify-end items-center pb-2">
        <div className="flex gap-4 items-center">
          <SearchInput
            value={searchTerm}
            onChange={(val) => setSearchTerm(val)}
            placeholder="Search Meal"
          />
          <Button className="bg-primary text-white" onClick={handleAddClick}>
            <span className="text-2xl pr-1">+</span> Add
          </Button>
        </div>
      </div>

      <MealTable searchTerm={searchTerm} onEditClick={handleEditClick}         onDeleteClick={handleDeleteClick}
/>

      {showFilter && <MealFilter close={()=>setShowFilter(false)}  editData={editData} />}

          <DeleteModal
                isOpen={isDeleteOpen}
                closeModal={() => setIsDeleteOpen(false)}
                handleDeleteAction={handleDeleteAction}
                itemId={deleteId}
              />
    </div>
  );
};

export default SettingMeal;
